import { configureStore } from "@reduxjs/toolkit";
import { reducer } from "../reduxReducers/Reducer";

export const store = configureStore({ reducer });
